import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { ReleaseSettings } from '../../release/models/releaseSettings.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ReleaseService } from '../../release/services/release.service';
import { MatDialog } from '@angular/material/dialog';
import { FileService } from '../../shared/services/file.service';

@Component({
  selector: 'app-release-history',
  templateUrl: './release-history.component.html',
  styleUrl: './release-history.component.scss'
})
export class ReleaseHistoryComponent extends AbstractBiditComponent implements OnInit {  

  releaseHistory: ReleaseSettings[];
  dataSource = new MatTableDataSource<ReleaseSettings>();

  displayedColumns: string[] =
    ['releaseSettings_Description', 'releaseSettings_Summary', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(deviceDetectorService: DeviceDetectorService,
    private releaseService: ReleaseService, private fileService: FileService) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.loadReleaseHistory();
  }

  loadReleaseHistory() {
    this.releaseService.getList()
      .subscribe({
        next: (data) => {
          this.releaseHistory = data;
          this.dataSource.data = this.releaseHistory;
        },
        error: (error: string) => this.onError(error)
      });
  }

  downloadAttachment(releaseSetting: ReleaseSettings) {
    this.releaseService.getReleaseAttachment(releaseSetting.releaseSettings_ID)
      .subscribe({
        next: (data) => {
          this.fileService.downloadFile(data, releaseSetting.releaseSettings_FileName);
        }
      });
  }
}
